import request from '../libs/request';

const res = 'Task';

export default {
  do(id, outcomeID, data, comment) {
    return request({
      url: `api/${res}/do`,
      method: 'post',
      data: {
        id,
        outcomeID,
        data,
        comment
      }
    });
  },
  reject(id, comment) {
    return request({
      url: `api/${res}/reject`,
      method: 'post',
      data: {
        id,
        comment
      }
    });
  },
  back(id, comment) {
    return request({
      url: `api/${res}/back`,
      method: 'post',
      data: {
        id,
        comment
      }
    });
  },
  redirect(id, targetID, comment) {
    return request({
      url: `api/${res}/redirect`,
      method: 'post',
      data: {
        id,
        targetID,
        comment
      }
    });
  },
  queryMy(filter) {
    return request({
      url: `api/${res}/queryMy`,
      method: 'post',
      data: filter
    });
  }
};
